import { Component, ojs, app, v, eData, payload } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { monetary, oneOf, either } from "../../helpers";
import { uc, gc } from "../../declarations";

const h = app("h");
const broker = app("broker");
const route = app("router");
const $e = app("$e");

export default class OfflineMpesaForm extends Component {
	render(...args) {
		return h.div(
			h.h5(
				{ class: "fw-bold mb-3 text-secondary" },
				"Pay Offline (Manual)"
			),

			h.div(
				{ class: "card border-0 shadow-sm rounded-4" },
				h.div(
					{ class: "card-body p-4" },
					h.form(
						h.div(
							{
								class: "alert alert-info rounded-3 mb-4 d-flex gap-3 align-items-start",
							},
							h.i({ class: "bi bi-info-circle-fill fs-5 mt-1" }),
							h.div(
								h.p({ class: "mb-1 fw-bold" }, "Instructions:"),
								h.p(
									{ class: "mb-0 small" },
									"Go to your M-Pesa App or SIM Toolkit and pay using Buy Goods & Services."
								)
							)
						),

						h.div(
							{ class: "bg-light rounded-4 p-3 mb-4" },

							// Amount Row
							h.div(
								{
									class: "d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom",
									role: "button",
									onclick: this.method(
										"copy",
										"${dom.get(`[offline-mpesa-amount='true']`).value}"
									),
									title: "Click to copy amount",
								},
								h.span(
									{
										class: "text-muted small fw-bold text-uppercase",
									},
									"Amount"
								),
								h.div(
									{
										class: "d-flex align-items-center gap-2",
									},
									h.span(
										{
											class: "fw-bold text-dark fs-5",
											id: "offline-mpesa-amount-holder",
										},
										v(uc.currentPaymentAmount, (amount) => {
											let v = amount.value - 0;
											let charge = this.charges(v);
											v += charge;
											return [
												monetary(
													v,
													route.params.currency
												),
												h.input({
													type: "hidden",
													offline_mpesa_amount:
														"true",
													value: v,
												}),
											];
										})
									),
									h.i({ class: "bi bi-copy text-primary" })
								)
							),

							// Till Number Row
							h.div(
								{
									class: "d-flex justify-content-between align-items-center",
									role: "button",
									onclick: this.method("copy", 7693551),
									title: "Click to copy till number",
								},
								h.span(
									{
										class: "text-muted small fw-bold text-uppercase",
									},
									"Till Number"
								),
								h.div(
									{
										class: "d-flex align-items-center gap-2",
									},
									h.span(
										{ class: "fw-bold text-dark fs-5" },
										"7693551"
									),
									h.i({ class: "bi bi-copy text-primary" })
								)
							)
						),

						h.div(
							{ class: "form-group mb-4" },
							h.label(
								{
									for: "offline-mpesa-payment-number",
									class: "form-label fw-bold text-secondary small",
								},
								"PHONE NUMBER"
							),
							h.div(
								{ class: "input-group input-group-lg" },
								h.span(
									{
										class: "input-group-text bg-light border-0 text-muted",
									},
									h.i({ class: "bi bi-phone" })
								),
								h.input({
									type: "text",
									class: "form-control bg-light border-0 fw-bold",
									id: "offline-mpesa-payment-number",
									placeholder: "e.g. 0712345678",
									value: oneOf(gc?.user?.value?.phone, ""),
								})
							),
							h.small(
								{ class: "form-text text-muted mt-1" },
								"Enter the phone number used to make the payment."
							)
						),

						h.div(
							{ class: "form-group mb-4" },
							h.label(
								{
									for: "offline-mpesa-transaction-id",
									class: "form-label fw-bold text-secondary small",
								},
								"MPESA CONFIRMATION SMS"
							),
							h.textarea({
								class: "form-control bg-light border-0",
								id: "offline-mpesa-transaction-id",
								rows: "3",
								placeholder:
									"Paste the full M-Pesa message here...",
								oninput: this.method(
									"parseTransactionId",
									"${this}"
								),
							}),
							h.small(
								{ class: "form-text text-muted mt-1" },
								"Copy and paste the entire M-Pesa confirmation SMS."
							)
						),

						h.div(
							{ class: "form-check mb-4" },
							h.input({
								type: "checkbox",
								class: "form-check-input",
								id: "terms-and-condition-offline",
								checked: either(
									localStorage.getItem("paymentTc") == 1,
									true
								),
							}),
							h.label(
								{
									class: "form-check-label text-muted small",
									for: "terms-and-condition-offline",
								},
								"I agree to Carata ",
								h.a(
									{
										href: "https://carata.co.ke/html/terms_conditions.php",
										target: "_blank",
										class: "text-decoration-none",
									},
									"Terms and Conditions"
								)
							)
						),

						h.button(
							{
								type: "button",
								class: "btn btn-success w-100 rounded-pill py-3 fw-bold shadow-sm",
								onclick: this.method("submit"),
							},
							"Submit Payment Details"
						)
					)
				)
			)
		);
	}

	submit() {
		let number = dom.id("offline-mpesa-payment-number");
		let transactionId = dom.id("offline-mpesa-transaction-id");

		let tc = dom.id("terms-and-condition-offline");
		let method = "offlineMpesa";

		let meta = {};
		let amount = null;
		if (route.qs.has("editable")) {
			amount = uc.currentPaymentAmount.value;
		}

		for (let [k, v] of route.qs.entries()) {
			meta[k] = v;
		}

		meta.method = method;

		broker.broadcast(
			$e.payment.needs.creation,
			eData(meta, {
				paymentData: {
					number: number?.value,
					transaction_id: transactionId?.value,
				},
				tc: tc?.checked ?? false,
				method,
				amount,
			})
		);
	}

	parseTransactionId(elem) {
		if (!elem?.value) return;

		elem.value = elem.value.split(/\s+/g)[0];
	}

	copy(text) {
		tool.toClipboard(text);
	}

	charges(amount) {
		let charge = 0;

		if (amount > 200) {
			charge = 0.0055 * amount;
		}

		if (charge > 210) {
			charge = 210;
		}

		return Math.floor(charge);
	}
}
